export default "__VITE_ASSET__CQuwP5ue__"